import ReturnsMetrics, {
  CalendarDate
} from '../../components/analytics-components/return-metrics/return-metrics'
import { useRegisterChatContext } from '@/ui/components/ai-chat'
import moment from 'moment'
import { useReturnRateAnalyticsAllowed } from '@/hooks/use-scope-platform'
import { NavigationTabs, TabProps } from '@/ui/shared/navigation-tabs'
import { useTranslation } from 'react-i18next'
import { AnalyticsFilterBar } from '@/ui/components/analytics-filters'
import { DateRangePicker, useAnalyticsDateRange } from '@/ui/shared/date-range'

function ReturnsAnalytics() {
  const { t } = useTranslation()

  useRegisterChatContext({
    tab: 'analytics',
    getPayload: () => ({ current_tab: 'analytics' })
  })

  const { fromDate, toDate, range, setRange } = useAnalyticsDateRange()
  const calendarDates: CalendarDate = {
    fromDate: fromDate ? moment(fromDate) : null,
    toDate: toDate ? moment(toDate) : null
  }

  const isReturnAnalyticsAllowed = useReturnRateAnalyticsAllowed()

  const tabs: TabProps[] = [
    {
      link: '/analytics/compensation',
      copy: t('product_analytics.return_amount')
    },
    {
      link: '/analytics/return-rates',
      copy: t('product_analytics.return_rate')
    }
  ]

  return (
    <div className="relative">
      {isReturnAnalyticsAllowed ? (
        <div className="sticky top-0 z-10">
          <NavigationTabs tabs={tabs} selectedIndex={0} />
        </div>
      ) : null}
      <div className="flex size-full flex-col items-center">
        <div className="flex w-full max-w-6xl flex-col items-center px-4">
          <div className="flex w-full max-w-6xl items-center justify-between pt-7">
            <AnalyticsFilterBar startDate={fromDate} endDate={toDate} />
            <div className="w-60">
              <DateRangePicker selected={range} onSelect={setRange} />
            </div>
          </div>

          <div className="mt-4 flex w-full justify-center">
            <ReturnsMetrics calendarDate={calendarDates} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReturnsAnalytics
